// Section file — populated during component conversion.
// Sections: navbar, header, pricing, faq, testimonials, footer
import React from "react";

const lang = {
  navbar: {
    holidays: {
      1: "OFERTA DE AÑO NUEVO",
      2: "OFERTA DE SAN VALENTÍN",
      3: "OFERTA DE SAN PATRICIO",
      4: "OFERTA DE PRIMAVERA",
      5: "OFERTA LOCURA DE MAYO",
      6: "OFERTA DE VERANO",
      7: "OFERTA DE JULIO",
      8: "OFERTA DE REGRESO A CLASES",
      9: "OFERTA ESPECIAL DE OTOÑO",
      10: "OFERTA DE HALLOWEEN",
      11: "OFERTA DE BLACK FRIDAY",
      12: "OFERTA DE TEMPORADA NAVIDEÑA",
    },
    fiftyOffAllPlans: "50% DE DESCUENTO EN TODOS LOS PLANES",
    logoAlt: "Ícono de gráfica",
    pricing: "Precios",
    faq: "FAQ",
    reviews: "Reseñas",
    logIn: "Iniciar sesión",
    getStarted: "Empieza a crecer",
    dashboard: "Panel",
    toggleMenu: "Abrir o cerrar menú",
  },
  header: {
    trustedBy: "Con la confianza de 50,000+ creadores",
    heroHeadline: "Haz crecer tus seguidores en Instagram",
    heroSub: "Nuestro equipo pone tu perfil frente a personas interesadas en tu contenido—para que crezcas con seguidores reales cada mes.",
    heroCta: "Empieza a crecer",
    trustHeading: "Con la confianza de más de 50,000 creadores y marcas",
    trustSub: "Creadores y marcas de todo el mundo confían en nosotros para hacer crecer sus cuentas.",
    trustStatFollowers: "9M+",
    trustStatFollowersLabel: "Seguidores entregados",
    trustStatRating: "4.9/5",
    trustStatRatingLabel: "De más de 2,400 reseñas",
    trustStatCreators: "50,000+",
    trustStatCreatorsLabel: "Creadores atendidos",
    proofRating: "4.9/5",
    proofReviews: "2,400+ reseñas",
    proofCreators: "50,000+ creadores",
    proofFollowers: "9M+ seguidores entregados",
    titlePre: "Seguidores reales y orgánicos de",
    titlePost: "",
    subtitle: "Gana miles de seguidores reales y comprometidos cada mes con segmentación personalizada por IA.",
    getStarted: "Empieza a crecer",
    noPassword: "Sin contraseña",
    cancelAnytime: "Cancela cuando quieras",
    resultsWithin24: "El crecimiento empieza al instante",
    card1Title: "Cómo hacemos crecer tu cuenta",
    card1Sub: "Ponemos tu perfil frente a personas a las que de verdad les interesa lo que publicas.",
    card1Items: [
      "Encontramos y alcanzamos personas interesadas en tu contenido",
      "Nosotros nos encargamos — tú solo sigue publicando",
      "Sin contraseña",
      "El crecimiento empieza al instante",
    ],
    card2Title: "Todo incluido",
    card2Sub: "Herramientas extra para crear mejor contenido y seguir tu crecimiento.",
    card2Items: [
      "Asistente de contenido con IA",
      "Panel de analíticas de crecimiento",
      "Herramientas de optimización de perfil",
      "Descargador de medios en 4K",
    ],
    platformLabel: "Servicio de crecimiento en Instagram",
    dashboardLabel: "Panel de analíticas",
    dashboardTitle: "Tu centro de control de crecimiento todo en uno",
    dashboardSub: "Dinos exactamente a quién segmentar — intereses, ubicación y qué tan rápido quieres crecer. Cámbialo cuando quieras desde tu panel.",
    viewPricing: "Ver precios",
    seePricing: "Elige tu plan",
    watchHowItWorks: "Mira cómo funciona",
    featuredIn: "Destacado en",
  },
  pricing: {
    heading: "Elige qué tan rápido quieres crecer",
    sub: (
      <>
        <span className="stripe-phrase">Sin bots. Sin cuentas falsas.</span>{" "}
        <span className="stripe-phrase">Crecimiento real y comprometido.</span>
      </>
    ),
    skippedInvoice: (
      <>Tienes una factura pendiente este mes. <a href="/dashboard/settings?tab=invoices" className="text-danger text-decoration-underline">Por favor paga tu factura</a> para seguir usando nuestros servicios.</>
    ),
    socialProof: "Con la confianza de 50,000+ creadores y marcas",
    mostPopular: "El más popular",
    plans: {
      pro: {
        name: "Plan Pro",
        blurb: "Para marcas serias que quieren el crecimiento más rápido y con máxima prioridad.",
        cta: "Empieza a crecer",
        features: [
          { feature: "40,000+ seguidores", description: "Crecimiento de seguidores acelerado y continuo, entregado gradualmente con el tiempo." },
          { feature: "Empieza a crecer en 24 horas", description: "Crecimiento natural y gradual que mantiene el impulso sin picos." },
          { feature: "Seguidores segmentados por nicho", description: "Seguidores reales y comprometidos afines a tu nicho, de nuestra red global de usuarios activos." },
          { feature: "Acceso al panel de crecimiento", description: "Sigue tu crecimiento de seguidores, monitorea tu progreso y consulta analíticas detalladas en cualquier momento." },
          { feature: "Actividad de interacción mejorada", description: "Más likes, vistas e interacciones para mantener tus publicaciones activas y visibles." },
          { feature: "Segmentación con IA", description: "Segmentación inteligente que muestra tu contenido a usuarios con alta intención y más propensos a interactuar." },
          { feature: "Herramientas de contenido con IA", description: "Acceso ilimitado al generador de captions con IA, analizador de tendencias, revisor de publicaciones y generador de ideas de contenido." },
          { feature: "Gerente de cuenta dedicado", description: "Un especialista en crecimiento dedicado a tu cuenta para estrategia personalizada y soporte prioritario." },
        ],
      },
      basic: {
        name: "Plan Básico",
        blurb: "Ideal para creadores que quieren un crecimiento más rápido y constante.",
        cta: "Empieza a crecer",
        features: [
          { feature: "10,000+ seguidores", description: "Crecimiento constante de seguidores entregado a lo largo de tu ciclo de facturación." },
          { feature: "Empieza a crecer en 24 horas", description: "Crecimiento natural y gradual que mantiene el impulso sin picos." },
          { feature: "Seguidores reales y orgánicos", description: "Seguidores reales y orgánicos de nuestra red global de usuarios activos." },
          { feature: "Acceso al panel de crecimiento", description: "Sigue tu crecimiento de seguidores, monitorea tu progreso y consulta analíticas detalladas en cualquier momento." },
          { feature: "Actividad de interacción mejorada", description: "Más likes, vistas e interacciones para mantener tus publicaciones activas y visibles." },
          { feature: "Segmentación con IA", description: "Segmentación inteligente que muestra tu contenido a usuarios con alta intención y más propensos a interactuar." },
          { feature: "Herramientas de contenido con IA", description: "Acceso ilimitado al generador de captions con IA, analizador de tendencias, revisor de publicaciones y generador de ideas de contenido." },
        ],
      },
      starter: {
        name: "Plan Inicial",
        blurb: "Una forma simple de empezar a crecer.",
        cta: "Empieza a crecer",
        features: [
          { feature: "3,000+ seguidores", description: "Crecimiento ligero y constante de seguidores, entregado gradualmente con el tiempo." },
          { feature: "Empieza a crecer en 24 horas", description: "Crecimiento natural y gradual que mantiene el impulso sin picos." },
          { feature: "Seguidores reales y orgánicos", description: "Seguidores reales y orgánicos de nuestra red global de usuarios activos." },
          { feature: "Acceso al panel de crecimiento", description: "Sigue tu crecimiento de seguidores, monitorea tu progreso y consulta analíticas detalladas en cualquier momento." },
        ],
      },
    },
    perMo: "/mes",
    onlyPerDay: (n) => `Solo $${n}/día`,
    fiftyOff: "50% OFF",
    linkYourProfileBtn: "Vincula tu perfil",
    linkYourProfileTitle: "Vincula tu perfil",
    trustLine: (
      <>
        <span className="stripe-phrase">Cancela cuando quieras ·</span>{" "}
        <span className="stripe-phrase">Pago seguro ·</span>{" "}
        <span className="stripe-phrase">Configuración instantánea</span>
      </>
    ),
    guaranteeHeading: "Resultados garantizados o te devolvemos tu dinero",
    guaranteeBody: "Entregamos los seguidores prometidos o te reembolsamos la diferencia — sin hacer preguntas.",
    noPasswordRequired: "No se requiere contraseña",
    noContracts: "Sin contratos",
    cancelAnytime: "Cancela cuando quieras",
    scheduledFor: (date) => `Programado para el ${date}`,
    unknown: "Desconocido",
    currentPlan: "Plan actual",
    switchToMonthly: "Cambiar a mensual",
    downgrade: "Bajar de plan",
    upgrade: "Mejorar plan",
    selected: "Seleccionado",
    confirmPlanChange: "Confirmar cambio de plan",
    planChangeDetails: "Detalles del cambio de plan",
    profileAlt: "Perfil",
    accountLabel: (platform) => `Cuenta de ${platform}`,
    currentPlanLabel: "Plan actual:",
    newPlanLabel: "Plan nuevo:",
    billingIntervalLabel: "Intervalo de facturación:",
    priceLabel: "Precio:",
    planTitle: (name) => `Plan ${name}`,
    pricePerMonth: (p) => `$${p}/mes`,
    billingInformation: "Información de facturación",
    proratedRefund: (value, days) => (
      <>Tu nuevo plan se activará de inmediato. Agregaremos un reembolso prorrateado de <span className="font-semibold">${value}</span> a tu cuenta según el tiempo restante de tu suscripción ({days} días).</>
    ),
    billingCycleReset: "Tu ciclo de facturación se reiniciará a partir de hoy, y los próximos cargos ocurrirán en esta fecha.",
    paymentMethod: "Método de pago",
    addNewCard: "Agregar nueva tarjeta",
    cardNumberLabel: "Número de tarjeta",
    expiryLabel: "Vencimiento",
    cvvLabel: "CVV",
    expPlaceholder: "MM/AA",
    errSelectPayment: "Por favor selecciona un método de pago",
    errFillCardDetails: "Por favor completa todos los datos de la tarjeta",
    errUpgrading: (e) => `Error al actualizar la suscripción: ${e}`,
    errChangePlanFallback: "No se pudo cambiar el plan",
    cancel: "Cancelar",
    processing: "Procesando...",
    confirmChanges: "Confirmar cambios",
  },
  faq: {
    label: "Preguntas frecuentes",
    heading: "Preguntas comunes",
    sub: "Todo lo que necesitas saber antes de comenzar.",
    items: [
      {
        title: "¿Los seguidores son reales?",
        content: "Sí. Nuestro equipo de expertos hace crecer tu audiencia con cuentas reales e interacción real — nunca con bots.",
      },
      {
        title: "¿Necesito darles mi contraseña?",
        content: "No. Nunca te pedimos tu contraseña, solo tu nombre de usuario público. Tu cuenta permanece totalmente bajo tu control y puedes detenerte cuando quieras.",
      },
      {
        title: "¿Es seguro de usar?",
        content: "Sí. Nunca necesitamos tu contraseña, solo tu nombre de usuario público. Miles de creadores y negocios crecen con nosotros todos los días.",
      },
      {
        title: "¿Qué es ViralGPT?",
        content: "Somos un equipo de crecimiento para creadores, marcas y negocios. Eliges un paquete de seguidores, lo entregamos en tu cuenta — y tu panel suma herramientas de IA para captions, tendencias y analíticas.",
      },
      {
        title: "¿Qué tengo que hacer?",
        content: "Después de registrarte, danos tu nombre de usuario de Instagram y elige un plan. Nosotros nos encargamos del resto — tú sigue publicando y mantienes el control total de tu cuenta.",
      },
      {
        title: "¿Qué tan rápido veré resultados?",
        content: "Muchos usuarios comienzan a ver mayor interacción y crecimiento de seguidores en los primeros días, dependiendo de su nicho, actividad y constancia.",
      },
      {
        title: "¿Funcionará para mi nicho?",
        content: "Sí. Trabajamos con influencers, marcas, músicos, creadores de fitness, agentes de bienes raíces, podcasts, negocios locales y más.",
      },
      {
        title: "¿Es una suscripción?",
        content: "El paquete en sí es un pago único. También incluye nuestro servicio de reposición automática, que mantiene tus seguidores al día cuando algunas cuentas se dan de baja — se renueva por $19.99, con el primer cobro 7 días después de tu compra y cada 28 días a partir de entonces. Puedes cancelarlo cuando quieras desde tu panel y conservar los seguidores que ya tienes.",
      },
      {
        title: "¿Se quedan los seguidores?",
        content: "Los seguidores entregados son tuyos. Algunas cuentas dejan de seguir con el tiempo, algo normal en Instagram — para eso está la reposición automática. Si la cancelas, los seguidores que ya tienes permanecen en tu cuenta.",
      },
    ],
    publicOnlyItems: [
      {
        title: "¿Se me volverá a cobrar?",
        content: "El paquete es un pago único y no se vuelve a cobrar. Tu compra incluye el servicio de reposición automática por $19.99, cobrado 7 días después de comprar y cada 28 días a partir de entonces, que puedes cancelar cuando quieras desde tu panel.",
      },
      {
        title: "¿Cómo puedo obtener un reembolso?",
        content: (
          <>
            Puedes solicitar un reembolso en cualquier momento a través de nuestro portal de reembolsos en línea en{' '}
            <a href="https://viralgpt.com/refund" className="text-instagram" style={{ textDecoration: 'underline' }}>
              https://viralgpt.com/refund
            </a>{' '}
            o escribiendo a{' '}
            <a href="mailto:support@viralgpt.com" className="text-instagram" style={{ textDecoration: 'underline' }}>
              support@viralgpt.com
            </a>.
          </>
        ),
      },
    ],
  },
  testimonials: {
    verifiedResults: "RESULTADOS VERIFICADOS",
    heading: "Resultados de clientes reales",
    sub: "Creadores reales. Cuentas reales. Crecimiento real y medible.",
    fromReviews: "de 2,400+ reseñas",
    reviews: {
      daniel_slovak: "La segmentación de Instagram de ViralGPT es increíble. Pasé de 10k a 40k seguidores reales llegando a personas que aman el contenido fitness como el mío.",
      smoke: "ViralGPT es la herramienta de crecimiento que todo creador serio necesita. Mi interacción se disparó y los seguidores están genuinamente interesados en mi contenido.",
      vikky: "Me costaba hacer crecer mis seguidores. ViralGPT me ayudó a llegar a la audiencia correcta y ganar seguidores reales y comprometidos.",
    },
    growthLabel: "Crecimiento",
    verifiedAlt: "Verificado",
    smokeTitle: "CEO de TopTree · 359k seguidores",
    followersCount: (n) => `${n} seguidores`,
    asFeaturedOn: "Destacado en",
    ctaButton: "Empieza a crecer hoy",
    ctaSub: "No se requiere contraseña · Compra única · La entrega empieza de inmediato",
    whyLabel: "Por qué importa",
    whyHeading: "Por qué importan más seguidores",
    whySub: "Convierte seguidores en resultados reales para tu negocio.",
    whyCards: [
      { title: "Atrae colaboraciones con marcas", desc: <>Desbloquea más <strong>acuerdos con marcas</strong> y oportunidades de <strong>patrocinio</strong>.</> },
      { title: "Genera clics en el link de tu bio", desc: <>Convierte seguidores en <strong>visitas a tu perfil</strong> y <strong>clics en tu link</strong>.</> },
      { title: "Convierte más clientes", desc: <>Aumenta la <strong>confianza</strong> y convierte más <strong>visitantes</strong> en <strong>clientes</strong>.</> },
    ],
  },
  footer: {
    platformHeading: "Haz crecer tu audiencia en cualquier plataforma",
    platforms: [
      { title: "Domina Instagram", sub: "Más seguidores" },
      { title: "Hazte viral en TikTok", sub: "Crecimiento explosivo" },
      { title: "Domina YouTube", sub: "Más suscriptores" },
      { title: "Construye tu imperio en X", sub: "Más seguidores" },
    ],
    tryHeading: <>Prueba <span className="text-instagram">ViralGPT</span> hoy</>,
    riskFree: "Comienza sin riesgo con nuestra garantía de devolución de dinero de 7 días.",
    getStarted: "Comenzar",
    description: "La plataforma #1 impulsada por IA para hacer crecer tus seguidores en redes sociales de forma orgánica. Obtén seguidores reales, interacción y resultados con nuestras herramientas avanzadas de segmentación y automatización.",
    terms: "Términos de servicio",
    privacy: "Política de privacidad",
    refundPolicy: "Política de reembolsos",
    allRightsReserved: "Todos los derechos reservados.",
  },

  // Paquetes públicos de seguidores, pago único. Solo se promete lo que se
  // entrega: cantidad de seguidores, precio único por ellos, y el servicio de
  // reposición automática incluido — que se renueva, y siempre debe decirse.
  packages: {
    heading: "Elige tu paquete",
    subheading: "Un solo pago por tus seguidores, más reposición automática para conservarlos.",
    valueProp: "Seguidores IG reales · Entrega rápida · Sin contraseña",
    followers: "seguidores",
    oneTime: "pago único",
    mostPopular: "Más popular",
    bestValue: "Mejor valor",
    cta: (followers, price) => `Consigue ${followers} seguidores — $${price}`,
    noSubscription: "Compra única. Incluye reposición automática por $19.99 tras 7 días, cancela cuando quieras.",
  },
};

export default lang;
